import get from "lodash/get"
import { languageIsRTL } from "../../../configure/i18n"
import { getLuminance } from "@material-ui/core/styles/colorManipulator"

function ContrastColor(color) {
    if(color){
        return (getLuminance(color) > 0.5) ?   "rgb(0,0,0, 0.2)" : "rgb(255, 255, 255, 0.2)"
    }
}

const styles = theme => {
    const primaryColor = get(theme, "appicalTheme.primary")
    return ({
    appBar: {
        filter: "brightness(0.985)",
        boxShadow: "none",
        height: get(theme, "appicalTheme.sizes.navigationBarHeight"),

        [theme.breakpoints.down("xs")]: {
            height: "unset",
        },
    },

    toolbar: {
        minHeight: "100%",
        padding: `0 ${get(theme, "appicalTheme.spacing.smallest")}`,

        [theme.breakpoints.down("xs")]: {
            minHeight: get(theme, "appicalTheme.sizes.appBarHeight"),
            padding: `0 ${get(theme, "appicalTheme.spacing.smallest")}`,
            justifyContent: "space-between"
        },
    },

    toolbarNoMiddle: {
        justifyContent: "space-between",
    },

    toolbarOnlyRightElement: {
        justifyContent: "flex-end",
    },

    transparent: {
        backgroundColor: "transparent",
    },

    leftButton: {
        marginRight: "28px",
        padding: "4px",
        transform: languageIsRTL() ? "rotate(180deg)" : "",
        "&:focus-visible": {
            borderStyle: "solid",
            borderWidth: "2px",
            borderColor: "rgba(0,0,0,1)",
            outline: "1px solid rgba(255,255,255,1)",
            outlineOffset: "-3px",
            filter: "drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.8))",
            borderRadius: "4px"
        },
    },

    title: {
        [theme.breakpoints.down("xs")]: {
            flex: "1 auto",
            paddingRight: "30%"
        },
        maxWidth: "200pt",
        wordWrap: "break-word",
        textAlign: "center",
        minWidth: "100pt",
        padding: "6px 12px"
    },

    tabs: {
        minHeight: "100%",
        display: "flex",
        flex: "1 auto",

        [theme.breakpoints.down("xs")]: {
            minHeight: "0",
            paddingTop: "0",
            display: "block",
        },
    },

    tab: {
        [theme.breakpoints.up("md")]: {
            minWidth: "130px",
        },
        [theme.breakpoints.up("sm")]: {
            minWidth: "80px",
        },
        "&:focus-visible": {
            borderStyle: "solid",
            borderWidth: "2px",
            borderColor: "rgba(0,0,0,1)",
            outline: "1px solid rgba(255,255,255,1)",
            outlineOffset: "-3px",
            filter: "drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.8))",
            borderRadius: "4px"
        },
        "&:hover": {
            backgroundColor: ContrastColor(primaryColor)
        },
        opacity: 1,
        paddingTop: "16px",
        paddingBottom: "19px"
    },

    tabLabel: {
        "& > span": {
            padding: "6px 12px",
        },
    },
    tabIndicator: {
        height: "3px",

    },
})}

export default styles
